var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"flex_c h100 flex1"},[_c('video',{ref:"audio",staticClass:"w100 flex1",staticStyle:{"height":"50px"},attrs:{"src":_vm.Fn.hashToUrl(_vm.url),"preload":"metadata","controls":"","controlslist":"nodownload","muted":""},domProps:{"muted":true}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }